export default __webpack_public_path__ + "static/media/aundev.9e4d9fdd.png";